// Bilingual translations RO/EN. Single source of truth.
const translations = {
  ro: {
    nav: {
      home: "Acasa",
      rates: "Cursuri",
      converter: "Convertor",
      about: "Despre noi",
      locations: "Locatii",
      loyalty: "Fidelitate",
      contact: "Contact",
      admin: "Admin",
    },
    hero: {
      since: "Din 1995",
      title_1: "Schimb valutar",
      title_2: "in inima",
      title_3: "Constantei.",
      subtitle:
        "30 de ani de incredere. 12 puncte de lucru in Constanta, Navodari si Mangalia. 14 valute. Curs negociabil.",
      cta_rates: "Vezi cursul de azi",
      cta_locations: "Toate locatiile",
      live: "CURS LIVE",
      kpi_branches: "puncte de lucru",
      kpi_currencies: "valute",
    },
    rates: {
      kicker: "Curs valutar — actualizat automat",
      title: "Cursurile noastre, in timp real",
      subtitle:
        "Cumparam si vindem valuta la cursuri afisate transparent, alaturi de cursul oficial BNR. Cursurile sunt negociabile in functie de sumele tranzactionate.",
      currency: "Valuta",
      buy: "Cumparare",
      sell: "Vanzare",
      bnr: "Curs BNR",
      last_update: "Ultima actualizare",
      negotiable: "Cursurile sunt negociabile in functie de sumele tranzactionate.",
      unit: { 1: "1", 100: "100" },
    },
    converter: {
      kicker: "Convertor valutar",
      title: "Calculeaza schimbul",
      from: "Din",
      to: "In",
      amount: "Suma",
      get: "Primesti",
      mode_buy: "Cumparare (aduci valuta)",
      mode_sell: "Vanzare (cumperi valuta)",
      tip: "Cursul afisat este orientativ. La sucursala primesti curs negociat in functie de suma.",
      ron: "Lei (RON)",
    },
    about: {
      kicker: "Despre Corsa Exchange",
      title: "Trei decenii de schimb valutar in Constanta.",
      p1: "Corsa International Change Office SRL a fost infiintata in 1995 si numara astazi 12 puncte de lucru in Constanta, Navodari si Mangalia.",
      p2: "Lista noastra cuprinde 14 valute, iar cursurile sunt negociabile in functie de sumele tranzactionate. Va oferim serviciile noastre cu promptitudine si profesionalism.",
      stat_year: "anul fondarii",
      stat_branches: "filiale active",
      stat_currencies: "valute disponibile",
    },
    moneygram: {
      kicker: "Transfer rapid international",
      title: "MoneyGram prin Smith&Smith",
      desc:
        "Trimite si primeste bani oriunde in lume in maxim 10 minute, prin reteaua MoneyGram disponibila in toate sucursalele Corsa Exchange.",
      badge: "~10 min · 200+ tari",
      bullets: [
        "Disponibil in 10 minute de la expediere",
        "Tranzactii in RON si EUR",
        "Fara comision la ridicare",
        "Peste 200 de tari, 350.000+ agentii",
      ],
    },
    locations: {
      kicker: "12 puncte de lucru",
      title: "Suntem unde ai nevoie.",
      subtitle: "Constanta · Navodari · Mangalia",
      cta_open: "Vezi pe harta",
      hours: "Program",
      phone: "Telefon",
    },
    map: {
      kicker: "Harta punctelor de lucru",
      all: "Toate",
      directions: "Directii",
      call: "Suna",
      view_page: "Vezi pagina",
      close: "Inchide",
      hint: "Apasa pe un punct de pe harta pentru detalii",
    },
    contact: {
      kicker: "Contact",
      title: "Hai sa vorbim.",
      hq: "Sediul Central",
      address: "Str. Poporului Nr. 23, Constanta",
      email: "Email",
      phone: "Telefon",
      mobile: "Mobil",
      fax: "Fax",
    },
    footer: {
      tagline: "Schimb valutar de incredere in Constanta din 1995.",
      links: "Navigare",
      legal: "Toate drepturile rezervate.",
      lang: "Limba",
    },
    admin: {
      login_title: "Acces administrator",
      email: "Email",
      password: "Parola",
      sign_in: "Autentificare",
      back: "Inapoi la site",
      dashboard: "Panou administrator",
      tab_rates: "Cursuri",
      tab_locations: "Locatii",
      refresh_bnr: "Reincarca BNR",
      save: "Salveaza",
      saved: "Salvat",
      logout: "Iesire",
      add_location: "Adauga locatie",
      edit: "Editeaza",
      delete: "Sterge",
      cancel: "Renunta",
      confirm_delete: "Sigur stergi locatia?",
    },
    common: {
      negotiable_short: "Curs negociabil",
      ron: "RON",
    },
  },
  en: {
    nav: {
      home: "Home",
      rates: "Rates",
      converter: "Converter",
      about: "About",
      locations: "Locations",
      loyalty: "Rewards",
      contact: "Contact",
      admin: "Admin",
    },
    hero: {
      since: "Since 1995",
      title_1: "Currency exchange",
      title_2: "in the heart of",
      title_3: "Constanta.",
      subtitle:
        "30 years of trust. 12 branches across Constanta, Navodari and Mangalia. 14 currencies. Rates are negotiable.",
      cta_rates: "Today's rates",
      cta_locations: "All locations",
      live: "CURS LIVE",
      kpi_branches: "branches",
      kpi_currencies: "currencies",
    },
    rates: {
      kicker: "Exchange rates — auto-updated",
      title: "Our rates, in real time",
      subtitle:
        "We buy and sell currency at transparent rates alongside the official BNR reference. Rates are negotiable depending on the transaction amount.",
      currency: "Currency",
      buy: "We buy",
      sell: "We sell",
      bnr: "BNR rate",
      last_update: "Last updated",
      negotiable: "Rates are negotiable depending on the transaction amount.",
      unit: { 1: "1", 100: "100" },
    },
    converter: {
      kicker: "Currency converter",
      title: "Calculate your exchange",
      from: "From",
      to: "To",
      amount: "Amount",
      get: "You get",
      mode_buy: "We buy from you",
      mode_sell: "We sell to you",
      tip: "Quoted rate is indicative. At the branch you may receive a negotiated rate depending on the amount.",
      ron: "Romanian leu (RON)",
    },
    about: {
      kicker: "About Corsa Exchange",
      title: "Three decades of foreign exchange in Constanta.",
      p1: "Corsa International Change Office SRL was founded in 1995 and operates today 12 branches across Constanta, Navodari and Mangalia.",
      p2: "Our offering covers 14 currencies, with rates negotiable based on the amount exchanged. Quick, reliable, professional service.",
      stat_year: "year founded",
      stat_branches: "active branches",
      stat_currencies: "currencies available",
    },
    moneygram: {
      kicker: "Fast international transfer",
      title: "MoneyGram via Smith&Smith",
      desc:
        "Send and receive money anywhere in the world in as little as 10 minutes, through the MoneyGram network available at every Corsa Exchange branch.",
      badge: "~10 min · 200+ countries",
      bullets: [
        "Available within 10 minutes of sending",
        "Transactions in RON and EUR",
        "No fee on receiving",
        "200+ countries, 350,000+ agents",
      ],
    },
    locations: {
      kicker: "12 branches",
      title: "Wherever you need us.",
      subtitle: "Constanta · Navodari · Mangalia",
      cta_open: "View on map",
      hours: "Hours",
      phone: "Phone",
    },
    map: {
      kicker: "Branch map",
      all: "All",
      directions: "Directions",
      call: "Call",
      view_page: "Open page",
      close: "Close",
      hint: "Tap a pin on the map for details",
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk.",
      hq: "Headquarters",
      address: "Poporului Street No. 23, Constanta",
      email: "Email",
      phone: "Phone",
      mobile: "Mobile",
      fax: "Fax",
    },
    footer: {
      tagline: "Trusted currency exchange in Constanta since 1995.",
      links: "Navigation",
      legal: "All rights reserved.",
      lang: "Language",
    },
    admin: {
      login_title: "Admin access",
      email: "Email",
      password: "Password",
      sign_in: "Sign in",
      back: "Back to site",
      dashboard: "Admin dashboard",
      tab_rates: "Rates",
      tab_locations: "Locations",
      refresh_bnr: "Refresh BNR",
      save: "Save",
      saved: "Saved",
      logout: "Logout",
      add_location: "Add location",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      confirm_delete: "Delete this location?",
    },
    common: {
      negotiable_short: "Negotiable rate",
      ron: "RON",
    },
  },
};

export default translations;
